@if (list.isHrProOrUpsellVisible()) {
  <decision-list-widget
    [title]="'Contract renewals' | translate"
    [state]="list.state()"
    [badgeLabel]="badgeLabel() | translate: { count: list.count() }"
    [clearMessage]="'Contracts to renew or end show up here.' | translate"
    [errorMessage]="'We couldn\'t load contract renewals.' | translate"
    [scopeLocation]="list.scopeLocation()"
    (retry)="list.reload()"
    (unlock)="list.openUpsell()"
  >
    @for (row of list.rows(); track row.contractId) {
      <li class="flex min-h-12 items-center gap-sm border-0 border-b border-solid border-default px-md py-sm">
        <span class="w-1/3 min-w-0 flex-none truncate text-sm text-default" data-hj-suppress>{{
          row.employeeName
        }}</span>
        <div class="flex min-w-0 flex-1 flex-col">
          <span
            class="text-sm"
            [class.text-danger]="row.tone === 'critical'"
            [class.font-semibold]="row.tone === 'critical' || row.tone === 'urgent'"
            [class.text-warning]="row.tone === 'urgent' || row.tone === 'warning'"
            [class.text-subtle]="row.tone === 'muted'"
            >{{ row.label | translate: row.labelParams }}</span
          >
          <span class="text-xs text-subtle">{{
            'Ends [date]' | translate: { date: (row.lastWorkingDay | localeDate: 'medium') }
          }}</span>
        </div>
        @if (row.link; as link) {
          <span class="flex-none text-right"
            ><a class="text-sm font-semibold text-brand" [routerLink]="link"
              >{{ 'Review' | translate }} <span class="sr-only" data-hj-suppress>{{ row.employeeName }}</span></a
            ></span
          >
        }
      </li>
    }
  </decision-list-widget>
}
